import React from "react";

const AwardiInner = () => {
  return (
    <>
      {/* Start Services area  */}
      <div className='service-area pd-top-45 pd-bottom-45 '>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-11 align-self-center'>
                <div className='about-inner-wrap'>
                  <div className='section-title mb-0'>
                  {/* <span className='subtitles'>NECC TELECOM</span> */}
                <h2 className='title' style={{marginBottom:"10px"}}>AWARDS & RECOGNITION</h2>
             
                  <p className='content'>
                  <strong>Parivahan Shresth Award for Shri Sunil Kumar Jain Ji:-</strong> In a function organized by AITWA, Shri Sunil Kumar Jain ( Managing Director- NECC Ltd.) was presented the prestigious award for notable contribution to the Transport Sector. The Hon’ble Vice President of India Sh. Bhairon Singh Sekhawat presented the award to Shri Sunil Kumar Jain.
                    </p>
          
                <p className='content'>
                <strong>Good Business Performance Award by “Inc. India 500”:-</strong> Sh Sunil Jain-MD NECC Ltd has been awarded for good business performance in the current years by “Inc. India 500”. This award is for his winning performance and stellar contribution to the Indian economy in terms of efficient entrepreneurship and growth.

                Service Tax notification No. 3/2013 dated 01-03-2013 Ministry of finance , has exempted the service provided by Goods Transport Agencies of (a) agriculture produce (b) food stuff including glours, tea, coffee, Jaggery, sugar, milk products, salt and edible oil and chemical fertilizer and oil cakes.

                T-2 Form (V.A.T.) made compulsory for import of goods into the sale of Delhi for dealer having turn over above 10 Crores.

                Sh. Sunil kumar Jain , C.M.D. NECC Ltd., reappointed Co-Chairman of “Task Force on Logistic Management PHD Chambers of Commerce.
                </p>
                <p className='content'>
                <strong>Mr Vinod R NAIR</strong>, H.R.Head NECC Ltd., awarded “Best H.R. Manager 2013” in logistic field by million – minds in their function held in Hotel Taj, Delhi.
                </p>
                 </div>
                </div>
              </div>
          </div>
        </div>
      </div>
      {/* End Services area  */}
    </>
  );
};

export default AwardiInner;
